<template>
  <ion-page>
    <ion-header />
    <ion-content fullscreen="true" :scroll-events="enableScrollEvent" @ionScroll="onScroll">
      <main>
        <div
          class="w-full h-full min-h-screen bg-paper register"
          :class="[register.stage === registerStage.COMPLETED ? 'bg-gradient' : '']"
          :style="{ '--register-gradient': `url(${REMOTE_ASSETS.registerBackgroundGradient})` }"
        >
          <div v-if="showBackButton" class="flex justify-between items-start px-[24px]">
            <BackButton class="!w-auto" :customBack="back" />
            <p
              v-if="stepDisplay"
              class="text-label-semibold text-grey-800 step-display"
              :class="stepDisplayClasses"
            >
              {{ stepDisplay }}
            </p>
          </div>
          <slot class="flex-1 page-bottom-padding" test="test"> </slot>
        </div>
      </main>
    </ion-content>
  </ion-page>
</template>

<script>
import { REMOTE_ASSETS } from '@/constants/REMOTE_ASSETS';
import { getStageConfig } from '@/constants/register/stageConfig';
import { REGISTER_STAGE } from '@/store/modules/profile';
import { IonContent, IonPage } from '@ionic/vue';
import { mapState } from 'vuex';
import BackButton from '@/components/common/BackButton.vue';
import { lockToPortrait } from '@/utils/screen-orientation';
import { isIosNativeOnly, isAndroidNativeOnly } from '@/utils/platform-check';

export default {
  name: 'RegisterPageLayout',
  components: {
    IonPage,
    IonContent,
    BackButton,
  },
  data() {
    return {
      REMOTE_ASSETS,
    };
  },
  computed: {
    ...mapState('profile', ['register']),
    registerStage() {
      return REGISTER_STAGE;
    },
    currentStageConfig() {
      return getStageConfig(this.register.stage);
    },
    showBackButton() {
      return this.currentStageConfig.showBackButton && !this.disableBack;
    },
    stepDisplay() {
      const { stepNumber, stepTotal } = this.currentStageConfig;
      return stepNumber && stepTotal ? `${stepNumber} of ${stepTotal}` : null;
    },
    stepDisplayClasses() {
      return {
        'step-display--ios': isIosNativeOnly(),
        'step-display--android': isAndroidNativeOnly(),
      };
    },
  },
  props: {
    enableScrollEvent: {
      type: Boolean,
      default: false,
    },
    disableBack: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    back() {
      this.$emit('back');
    },
    onScroll(event) {
      this.$emit('on-scroll', event);
    },
  },
  async mounted() {
    await lockToPortrait();
  },
  async beforeUnmount() {
    await lockToPortrait();
  },
};
</script>

<style scoped>
.register {
  padding-top: 0;
}

.bg-gradient {
  background-image: var(--register-gradient);
  background-repeat: no-repeat;
  background-size: 100% 70%;
}

/* Align step display with back button center */
.step-display {
  /* Vertically center with the back button (44px height) */
  line-height: 44px;
}

/* iOS: Match BackButton's effective top position (-8px margin + safe area padding) */
.step-display--ios {
  padding-top: calc(env(safe-area-inset-top, 0px) - 8px);
}

/* Android: Match BackButton's effective top position (max(8px, safe-area-inset-top)) */
.step-display--android {
  padding-top: max(8px, env(safe-area-inset-top, 8px));
}
</style>
